<template>
  <v-container id="welcome_root" fluid pa-0>
    <v-row justify="center" align="center" style="height:100vh" dense>
      <v-col cols="12" lg="6" md="6" align-self="center" class="d-flex flex-column justify-center align-center">
        <v-card elevation="4" class="px-8 py-4 " width="auto">
          <div class="d-flex flex-column justify-center align-center">
            <v-img class="mt-4 mb-0" contain :src="$store.state.currentTheme.colorLogo" height="27px"></v-img>
            <v-card-title>
              <span class="display-1 mt-3 mb-6 font-weight-bold">{{ $t('welcome.title') }}</span>
            </v-card-title>
            <v-btn id="login_button" color="primary" class="py-2 px-6" @click="login">
              {{ $t('welcome.button.loginOrRegister') }}
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    login() {
      this.$auth.login(this.$route.query.redirect || 'Dashboard')
    }
  }
}
</script>
